// extracted by mini-css-extract-plugin
module.exports = {"medium":"Logo-module--medium--3cfc65","small":"Logo-module--small--c05587"};